<template>
  <v-container class="home">
    <title-block />
    <principles-block />
    <footer-block />
  </v-container>
</template>
<style>
</style>

<script>
import FooterBlock from "@/components/Footer";
import TitleBlock from "@/components/AboutMethodTitleBlock";
import PrinciplesBlock from "@/components/AboutMethodPrinciplesBlock";

export default {
  name: "AboutMethod",
  components: { FooterBlock, TitleBlock, PrinciplesBlock },
  data() {
    return {
    };
  },
  mounted() {    
  },
  computed: {
  },
  methods: {
  },
};
</script>
<style lang="scss">
</style>
